
import Vue from 'vue'
import {Component, Prop} from 'vue-property-decorator'
import MenuGroupItem from "@/model/MenuGroupItem";
import DailyMenuOption from "@/model/DailyMenuOption";
import {GET_MODE} from "@/store/getter-types";
import {UserCredentialsPayload} from "@/types/payload";
import {ORDER_CONFIRMATION, SET_IS_ORDER_CONFIRMATION} from "@/store/action-types";
import {Action} from "vuex-class";
import {TranslateResult} from "vue-i18n";
import MenuReservationItem from "@/model/MenuReservationItem";
import _ from "lodash";
import i18n from "@/plugins/i18n";

@Component({
  components: {
  }
})
export default class ControlOrderDialog extends Vue {
  @Prop({type: Boolean, default: false}) readonly show!: boolean
  @Prop({type: Boolean, default: false}) readonly isMultipleGroupMenu!: boolean
  @Prop({type: Map, required: true}) currentSelection!: Map<MenuGroupItem, DailyMenuOption | DailyMenuOption[]>
  @Prop({type: Object, required: true}) topMenuGroup!: MenuGroupItem
  @Prop({type: Array, required: false}) reservationItem!: MenuReservationItem[] | undefined
  @Prop({type: String, required: true}) date!: any
  @Prop({type: Boolean, default: false}) readonly restore!: boolean
  @Prop({type: Boolean, default: false}) readonly isUpdate!: boolean
  @Prop({type: Boolean, default: false}) readonly showConfirmButtons!: boolean
  @Prop({type: Boolean, default: false}) readonly isMultiplePortion!: boolean
  @Prop({type: Boolean, default: false}) readonly isBoarderNote!: boolean
  @Prop({type: Array, required: true}) menuGroupList!: MenuGroupItem[]
  @Action(ORDER_CONFIRMATION) orderConfirmation!: ({ (payload: UserCredentialsPayload): Promise<boolean> })
  @Action(SET_IS_ORDER_CONFIRMATION) setIsOrderConfirmation!: ({ (payload: boolean): Promise<void> })

  private fetchInProgress = false
  private foodList: string[] = []
  private selectionPayload: Map<MenuGroupItem, DailyMenuOption | DailyMenuOption[]> = new Map()
  private userId: string = ''
  private username: string | null = null
  private partialUserId: string = ''
  private isInvalidCredentials: boolean = false
  private timeOutAlert: ReturnType<typeof setTimeout>  | null = null
  private eventKeyTimeOut: ReturnType<typeof setTimeout>  | null = null
  private description: string | null = null
  private boarderNoteRules: Array<(v: string | null) => string | boolean> = [
    (v: string | null) => v === null || (v !== null && v.length < 580) || i18n.t('orderPage.maxLengthBoarderNote').toString()
  ]

  get isConfirmButtonDisabled () {
    if(this.description && this.description.length > 580) {
      return true
    }
  }

  get getFilteredSubGroupList (): MenuGroupItem[] {
    let list: any[] = []
    this.menuGroupList.forEach((item: MenuGroupItem) => {
      item.subGroupList.forEach((i: MenuGroupItem) => {
        list.push(i)
      })
    })

    return list
  }

  getTitle (idx: number): any {
    let data: boolean[] = []
    this.getFilteredSubGroupList[idx].optionList.forEach((subGroupItem: DailyMenuOption) => {
      if(this.foodList.includes(subGroupItem.id)){
        data.push(true)
      } else {
        data.push(false)
      }
    })
    return data.includes(true)
  }

  get getButtonLabel (): TranslateResult | undefined {
    if(_.first(this.reservationItem) && _.first(this.reservationItem)!.status) {
      if (_.first(this.reservationItem)!.status === 'canceled') {
        return this.$t('orderPage.notRestoreReservation').toString()
      } else if (_.first(this.reservationItem)!.status === 'active'){
        return this.$t('orderPage.closeButtonLabel').toString()
      } else {
        return this.$t('orderPage.closeButtonLabel').toString()
      }
    }

    return this.$t('orderPage.closeCreateButtonLabel').toString()
  }

  get isKioskMode (): boolean {
    return  this.$store.getters[GET_MODE] === 'kiosk'
  }

  performSave(event: KeyboardEvent) {
    if(!this.fetchInProgress && !this.isInvalidCredentials) {
      if (event.key !== "Enter") {
        if(this.eventKeyTimeOut) {
          clearTimeout(this.eventKeyTimeOut)
        }
        this.eventKeyTimeOut = setTimeout( () => {
          this.partialUserId = ''
        }, 1000);
        if(event.key.length === 1 && event.code !== 'Space') {
          this.partialUserId += event.key
        }
      } else {
        if (this.eventKeyTimeOut) {
          clearTimeout(this.eventKeyTimeOut)
        }
        if (this.partialUserId.length > 0) {
          if (this.partialUserId.includes('lunchmenu.today')) {
            this.userId = this.partialUserId.slice(-36)
          } else {
            this.userId = this.partialUserId
          }
          this.partialUserId = ''
          this.isInvalidCredentials = false
          if (this.timeOutAlert) {
            clearTimeout(this.timeOutAlert)
          }
          this.fetchInProgress = true
          this.onLogUser(this.userId)
        }
      }
    }
  }

  async onLogUser(item: string): Promise<void> {
    const payload: UserCredentialsPayload = {
      username: item,
      password: 'qr'
    }
    this.setIsOrderConfirmation(true)
    const response: boolean = await this.orderConfirmation(payload)
    this.setIsOrderConfirmation(false)
    if(response){
      this.fetchInProgress = true

      this.$emit('confirm',this.selectionPayload)
    } else {
      window.addEventListener('keyup',this.performSave)
      this.isInvalidCredentials = true
      this.fetchInProgress = false
    }
  }

  onCloseButtonClick(): void {
    this.$emit('close')
  }

  onConfirmButtonClick(): void {
    this.fetchInProgress = true
    if(this.restore) {
      this.$emit('restoreOffer')
    } else {
      this.$emit('confirm', this.selectionPayload,this.description)
    }
  }

  isSubGroupItemTitle (subGroupItem: MenuGroupItem ): boolean {
    let conditions: boolean[] = []
    subGroupItem.optionList.forEach((item: DailyMenuOption) => {
    conditions.push(this.foodList.includes(item.id))
    })
    return conditions.some(v=>v)
  }

  mounted(): void {
    window.addEventListener('keyup',this.performSave)
    this.selectionPayload = this.currentSelection
    if(!this.isMultipleGroupMenu) {
      this.currentSelection.forEach((value: any, key: any) => {
        const foundItem: MenuGroupItem | undefined = this.topMenuGroup.subGroupList.find((item: MenuGroupItem) => item.id === key.id)
        if(foundItem) {
          if (value instanceof Array) {
            value.forEach((item: DailyMenuOption) => {
              this.foodList.push(item.id)
            })
          } else {
            this.foodList.push(value.id)
          }
        }
      })
    } else {
      this.currentSelection.forEach((value: any, key: any) => {
        if (value instanceof Array) {
          value.forEach((item: DailyMenuOption) => {
            this.foodList.push(item.id)
          })
        } else {
          this.foodList.push(value.id)
        }
      })
    }

    if(this.reservationItem){
      this.reservationItem?.forEach((item: any) => {
        this.description = item.boarderNote ? item.boarderNote : null
      })
    } else {
      this.description = null
    }
  }

  destroyed(){
    window.removeEventListener('keyup',this.performSave)
    if(this.timeOutAlert) {
      clearTimeout(this.timeOutAlert)
    }
    if(this.eventKeyTimeOut) {
      clearTimeout(this.eventKeyTimeOut)
    }
  }

}
